import type { FC, PropsWithChildren } from 'react';
import { PageProvider } from '@anywayseo/tools';

type PageWrapperProps = PropsWithChildren<{ location: Location }>;

const PageWrapper: FC<PageWrapperProps> = ({ children, location }) => {
  return <PageProvider location={location}>{children}</PageProvider>;
};

export default PageWrapper;
